import React from "react";

export default function Help(templateId) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "#272C34",
        color: "#ffffff",
        height: "60px",
      }}
    >
      This template doesn't exist. Do you have a new template idea? Please
      contact me on Discord:
      <a
        href="https://discordapp.com/users/DK_rudyairlines#6990"
        style={{ color: "#00bcd4", marginLeft: "8px" }}
      >
        rudyairlines#6990
      </a>
    </div>
  );
}
